export default {
  name: 'MonthlyRecord',
  props: {},
  data: function() {
    return {
      recordList: []
    };
  },
  computed: {}
};
